import { render } from "./NavBarComp.vue?vue&type=template&id=457527ff&scoped=true"
const script = {}

import "./NavBarComp.vue?vue&type=style&index=0&id=457527ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457527ff"]])

export default __exports__